import { User } from "../models/User";



export function calculateFilledPercentage(user: User): number {
  const relevantFields: (keyof User)[] = [
    'firstName',
    'lastName',
    'ageGroup',
    'city',
    'country',
    'linkedIn',
    'profileMessage',
    'profilePhoto',
    'aboutMe',
    'email',
  ];
    const filledFields = relevantFields.filter((key) => {
    const value = user[key];
    return typeof value === 'string' && value.trim() !== '';
  });

  const totalFields = relevantFields.length;
  const percentage = (filledFields.length / totalFields) * 100;
  return Math.round(percentage);
}

export default calculateFilledPercentage;